<template>
  <div>
    <div
      v-if="mode === 'read'"
      class="d-flex justify-content-between align-items-center gap-2"
      @dblclick="clickHandler"
    >
      <div
        class="w-100 mr-1"
      >
        {{ localRemark }}
      </div>
      <span
        @click="clickHandler()"
      >
        <feather-icon
          icon="Edit2Icon"
          size="16"
        />
      </span>
    </div>
    <div
      v-else
      class="d-flex justify-content-between align-items-center gap-2"
    >
      <b-form
        class="w-100 mr-1"
        @submit.prevent="updateRemarksHandler"
      >
        <b-form-input
          v-model="localRemark"
          type="text"
          :disabled="saving"
          autofocus
        />
      </b-form>
      <span v-if="saving">
        <b-spinner
          label="Small Spinner"
          small
        />
      </span>
      <span
        v-else
        @click="updateRemarksHandler()"
      >
        <feather-icon
          icon="SaveIcon"
          size="16"
        />
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BForm, BFormInput, BSpinner } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BForm, BFormInput, BSpinner,
  },
  props: {
    poItemId: {

      type: Number,
      required: true,

    },
    remark: {
      type: String,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      mode: 'read',
      localRemark: null,
      saving: false,
    }
  },
  watch: {
    remark(newVal) {
      this.localRemark = newVal
    },
  },
  mounted() {
    this.localRemark = this.remark
  },
  methods: {
    clickHandler() {
      this.mode = 'edit'
    },
    updateRemarksHandler() {
      if (this.saving) {
        return
      }

      this.saving = true

      axios.post('/update_po_item_remarks', {
        po_item_ids: [this.poItemId],
        remark: this.localRemark,
      }).then(() => {
        this.saving = false
        this.mode = 'read'
        this.$emit('remarksUpdated', [this.poItemId], this.localRemark)
      }).catch(error => {
        this.saving = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.response?.data?.error || 'Something went wrong!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    },
  },

}

</script>
